import React from 'react';
import { HeaderSkeleton } from 'site-modules/personalized-search/components/header-content/header-skeleton/header-skeleton';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './collapsible-overview-item-skeleton.scss';

export const CollapsibleOverviewItemSkeleton = () => (
  <div className="collapsible-overview-item-skeleton">
    <div className="d-flex align-items-center justify-content-between">
      <HeaderSkeleton withCtaSkeleton={false} />
      <Skeleton className="expand-button d-block rounded-6" />
    </div>
    <hr />
  </div>
);
